var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-indicator",attrs:{"aria-hidden":"true"}},[_c('Icon',{attrs:{"color":_vm.color,"type":"loading"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }